import { useLang } from '@/i18n';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

interface ItfItem {
    name: string;
    text: string;
    img: [string, string];
    link?: string;
}
const D: React.FC = () => {
    const { t } = useLang('stream.overview');
    const items: ItfItem[] = [
        {
            name: 'D_item1_name',
            text: 'D_item1_text',
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1784022075039-bl8ooo-compressed-Frame%202094654993.webp',
                'https://websiteoss.ecoflow.com/figma-uploads/1783932715281-vfarz7-compressed-20260623.jpg',
            ],
        },
        {
            name: 'D_item2_name',
            text: 'D_item2_text',
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1783933044217-i9wqqk-compressed-Frame%202094654994.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1783932886818-7pfesk-compressed-sl_dseb.jpg',
            ],
            link: 'https://nl.ecoflow.com/products/ecoflow-p1-meter',
        },
        {
            name: 'D_item3_name',
            text: 'D_item3_text',
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1783933047099-sksdfi-compressed-7.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1783932889829-vjd9n4-compressed-7.jpg',
            ],
        },
    ];

    useOnceInView('.stream-nl-D .title', () => {
        document.querySelector('.stream-nl-D .title')?.classList.add('enter');
        document.querySelector('.stream-nl-D .desc')?.classList.add('enter');
        document.querySelector('.stream-nl-D .items-pc')?.classList.add('enter');
        document.querySelector('.stream-nl-D .items-h5')?.classList.add('enter');
    });

    return (
        <div className={`${css.section} stream-nl-D GtmModuleData-section white space`} id="stream-nl-D" data-section-id={'stream-nl-D'}>
            <div className="info">
                <h2 className="title ani-1">{t('D_title')}</h2>
                <p className="desc ani-2">{t('D_desc')}</p>
            </div>
            <ul className="items box items-pc ani-3">
                {items?.map((item: ItfItem, i: number) => (
                    <li className="item" key={i}>
                        <EcoImg className="item-img" pc={item.img[0]} alt={item.text} />
                        <div className="item-info">
                            <p className="item-name">
                                {t.rich(item.name, {
                                    b: (tx: string) => <span className="b">{tx}</span>,
                                })}
                            </p>
                            <p className="item-text">{t(item.text)}</p>
                            {item?.link && (
                                <EcoLink className="item-link" href={item.link}>
                                    <span>{t('D_link')}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M7.99219 16.542L14.2573 12.0552L7.99219 7.56787L9.15674 5.94189L16.5571 11.2422C16.8192 11.43 16.9746 11.7328 16.9746 12.0552C16.9745 12.3776 16.8192 12.6804 16.5571 12.8682L9.15674 18.168L7.99219 16.542Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </EcoLink>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
            <div className="swiper-box">
                <Swiper slidesPerView={'auto'} spaceBetween={12} className="items box items-h5 ani-4">
                    {items?.map((item: ItfItem, i: number) => (
                        <SwiperSlide className="item" key={i}>
                            <EcoImg className="item-img" pc={item.img[1]} />
                            <div className="item-info">
                                <p className="item-name">
                                    {t.rich(item.name, {
                                        b: (tx: string) => <span className="b">{tx}</span>,
                                    })}
                                </p>
                                <p className="item-text">{t(item.text)}</p>
                                {item?.link && (
                                    <EcoLink className="item-link" href={item.link}>
                                        <span>{t('D_link')}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M7.99219 16.542L14.2573 12.0552L7.99219 7.56787L9.15674 5.94189L16.5571 11.2422C16.8192 11.43 16.9746 11.7328 16.9746 12.0552C16.9745 12.3776 16.8192 12.6804 16.5571 12.8682L9.15674 18.168L7.99219 16.542Z"
                                                fill="currentColor"
                                            />
                                        </svg>
                                    </EcoLink>
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default D;
